"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Env = void 0;
const constants_1 = require("./constants");
let Env = (() => {
    class Env {
        constructor(partial) {
            Object.assign(this, partial);
        }
        static prepare(env) {
            let partial = null;
            if (env) {
                switch (typeof env) {
                    case 'string':
                        partial = constants_1.SUPPORTED_ENVS[env];
                        break;
                    case 'object':
                        if (env.apiOptions && env.networkOptions) {
                            partial = env;
                        }
                        break;
                }
                if (!partial || !partial.apiOptions || !partial.networkOptions) {
                    throw new Error(`Unsupported env`);
                }
            }
            else {
                partial = constants_1.SUPPORTED_ENVS[this.defaultName || constants_1.EnvNames.TestNets];
            }
            return new Env(partial);
        }
    }
    Env.defaultName = constants_1.EnvNames.MainNets;
    return Env;
})();
exports.Env = Env;
